import React from 'react';
import { Star } from 'lucide-react';
interface TestimonialProps {
  name: string;
  location: string;
  text: string;
}
const TestimonialCard = ({
  name,
  location,
  text
}: TestimonialProps) => <div className="bg-brand-card p-4 md:p-5 rounded-xl border border-white/10 flex flex-col h-full hover:border-brand-accent/30 transition-colors" data-id="element-276">
    <div className="flex items-center mb-3" data-id="element-277">
      <div className="w-10 h-10 bg-brand-accent text-black rounded-full flex items-center justify-center font-bold text-lg mr-3 shrink-0" data-id="element-278">
        {name.charAt(0)}
      </div>
      <div data-id="element-279">
        <div className="flex text-brand-accent mb-0.5" data-id="element-280">
          {[...Array(5)].map((_, i) => <Star key={i} className="w-3 h-3 fill-current" data-id="element-281" />)}
        </div>
        <p className="font-bold text-white text-sm leading-tight" data-id="element-282">{name}</p>
        <p className="text-[10px] md:text-xs text-gray-500" data-id="element-283">📍 {location}</p>
      </div>
    </div>
    <p className="text-gray-400 text-sm italic flex-grow leading-relaxed" data-id="element-284">
      "{text}"
    </p>
  </div>;
export function TestimonialsSection2() {
  const testimonials = [{
    name: 'Marcelo D.',
    location: 'Rosario | Escuela Técnica N°2 — Automatización y Control',
    text: 'Por fin tengo fichas de PLC pensadas para la secundaria técnica. Antes buscaba en manuales de Siemens en inglés y adaptaba durante horas. Ahora entro al taller con la guía lista y los alumnos programan desde el primer módulo.'
  }, {
    name: 'Graciela P.',
    location: 'Buenos Aires | Maestra de Taller — Electromecánica',
    text: 'El tomo de lógica de control me cambió las clases. Los chicos entendieron el Ladder con la planilla de ejercicios. Antes les dibujaba en el pizarrón y no quedaba nada. Ahora programan ellos.'
  }, {
    name: 'Diego F.',
    location: 'Córdoba | Profesor de Automatización — 5° y 6° año',
    text: 'Mis alumnos nunca entendían para qué servía el GRAFCET. Con el Tomo 5 y el caso práctico de la secuencia neumática, lo resolvieron ellos mismos en el taller y no lo olvidaron más. Fue un antes y un después.'
  }, {
    name: 'Adriana L.',
    location: 'Tucumán | Docente de PLC — Técnica Industrial',
    text: 'Los proyectos integradores del upsell me salvaron el cierre de año. Tenía 3 grupos distintos, todos en distintos niveles, y necesitaba proyectos diferentes para cada uno. Ya los tenía todos listos con sus rúbricas. No inventé nada.'
  }, {
    name: 'Hernán V.',
    location: 'Mendoza | Maestro de Taller — Electromecánica',
    text: 'El banco de ejercicios resueltos es oro puro. Ya no tengo que inventar problemas de Ladder la noche anterior. Imprimo, reparto y los chicos practican con casos de automatización reales. Me devolvió los domingos.'
  }];
  return <section className="py-10 md:py-16 px-4 bg-brand-dark" data-id="element-285">
      <div className="max-w-5xl mx-auto" data-id="element-286">
        <h2 className="text-2xl md:text-3xl font-black text-center mb-8 text-white" data-id="element-287">
          ❤️ LO QUE DICEN LOS DOCENTES QUE YA LO TIENEN
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6" data-id="element-288">
          {testimonials.map((t, i) => <TestimonialCard key={i} {...t} data-id="element-289" />)}
        </div>
      </div>
    </section>;
}